/**
 * @vuepress
 * ---
 * title: AffectedTransformer
 * ---
 */

import Transformer from '../transformer'

/**
 * @class AffectedTransformer
 * @author Jose Luis R.
 */
class AffectedTransformer extends Transformer {
  static fetch({
    id, name
  }) {
    return {
      id, name
    }
  }
}

export default AffectedTransformer
